import gsap from "gsap"
import style from './Games.module.css'
import { useEffect, useState } from "react"
import logo from '../assets/Your paragraph text.png';


export default function Games()
{
    useEffect(() => {
        gsap.fromTo("#flashingText", {color: 'red',}, {color: "yellow", repeat: -1, yoyo: 'true'})
        gsap.fromTo("#flashingText", {x: -500}, {x: 500, repeat: -1, yoyo: 'true', duration: 10})
    })

    const [math, setMath] = useState([1, 2])

    return(
        <div className = {style.Container}>
            <h2>Games</h2>
            <img style = {{pointerEvents: 'none'}} className={style.Img} src = {logo} />

            <h2 className={style.Header} id = "flashingText">🀄 games </h2>


            <button>  ôi con bò cười xì hơi </button>

            <h2>Math game (for kids)</h2>
            <button onClick={() => {
                if(math[0] === 1) setMath([2, 1])
                else setMath([1, 2])
            }}>Click for math</button>
            <p>{`${math[0]} + ${math[1]}`}</p>
            <button 
            style = {{zIndex: 1000000}}
            onClick = {() => {window.open('https://www.youtube.com/watch?v=rsRz2L-lUZQ', '_blank')}}>Funny video (adult only)</button>

            <h2>moral: sometimes, game is the education</h2>
        </div>
    )
}